import { queryKeys } from '@/lib/useQuery/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCrm } from '.';

export function useUpdateCrm(orgId?: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: queryKeys.crm._def,
    mutationFn: updateCrm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.crm._def });
    },
  });
}
